function getBatched<T>(arr: Array<T>, batchSize: number): Array<Array<T>> {
	const batchCount = Math.ceil(arr.length / batchSize),
		batches = [];

	for (let i = 0; i < batchCount; i++) {
		batches.push(arr.slice(i * batchSize, (i + 1) * batchSize));
	}

	return batches;
}

export default {
	getBatched
};
